import { render, staticRenderFns } from "./CampaignPickls.vue?vue&type=template&id=1ef01a2f&scoped=true&"
import script from "./CampaignPickls.vue?vue&type=script&lang=ts&"
export * from "./CampaignPickls.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignPickls.vue?vue&type=style&index=0&id=1ef01a2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef01a2f",
  null
  
)

export default component.exports